// Client Account dashboard (LACW, VALS and EAS).
//
// The dashboard itself is served by the Render backend. The portal never talks to Render
// directly from the browser: requests go through /api/render-proxy, which authenticates the
// session and signs the upstream request. That is why the hosted URL below is relative -
// pointing an iframe straight at Render would bypass the proxy and the signing with it.
//
// Extracted from StandAloneGuidelines.jsx so the standalone routes can render this without
// pulling in the whole 3,000-line portal page.

export const CLIENT_ACCOUNT_IDS = ["lacw", "vals", "eas"];

export const CLIENT_ACCOUNT_LABELS = {
  lacw: "LACW Client Account",
  vals: "VALS Client Account",
  eas: "EAS Client Account",
};

// Local development runs the operator dashboard directly on 127.0.0.1; there is no proxy in
// front of it there, and no session to sign with.
const LOCAL_DASHBOARD_ORIGIN = "http://127.0.0.1:54322";

export function getClientAccountDashboardUrl(clientId) {
  const standalone = `${String(clientId || "").toLowerCase()}-client-account`;
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.includes("completelawsupport.com") || host.includes("vercel.app")) {
      return `/api/render/operator/dashboard?standalone=${standalone}&v=1.7`;
    }
  }
  return `${LOCAL_DASHBOARD_ORIGIN}/operator/dashboard?standalone=${standalone}&v=1.7`;
}

export function getClientAccountLabel(clientId) {
  const key = String(clientId || "").toLowerCase();
  return CLIENT_ACCOUNT_LABELS[key] || "Client Account";
}
